import { CustomTextArea } from '../../../../common/CustomTextArea';
import CustomTextField from '../../../../common/CustomTextField';
import {
  renderDropdownWithoutLabelMultiple,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';

const EmbryologyLiveBirthDetails = ({
  embryoTransferDetails,
  handleInputChange,
  handleGenderChange,
}) => {
  return (
    <div className="card">
      <h3 style={{ textAlign: 'center' }}>Live Birth Details</h3>

      <div className="body" style={{ display: 'flex', gap: '10px' }}>
        <table
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <tbody>
            <tr>
              <td>No of Children</td>
              <td>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={embryoTransferDetails.noOfChildren}
                  name={'noOfChildren'}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </td>
              <td>Gender</td>
              <td>
                {renderDropdownWithoutLabelMultiple(
                  'gender',
                  embryoTransferDetails.gender,
                  [' ', 'Male', 'Female'],
                  handleGenderChange,
                  undefined,
                  +embryoTransferDetails.noOfChildren &&
                    +embryoTransferDetails.noOfChildren > 0
                    ? +embryoTransferDetails.noOfChildren
                    : 1,
                )}
              </td>
              <td>Comments</td>
              <td>
                <CustomTextArea
                  minRows={2}
                  maxRows={3}
                  value={embryoTransferDetails.liveBirthDetailsComments}
                  onChange={handleInputChange}
                  name="liveBirthDetailsComments"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmbryologyLiveBirthDetails;
